<script setup>
import { onMounted, onUpdated, computed } from "vue";
import { useTreeStore } from '@/store/modules/trees.js';
import { Gems } from "@/gems";
import TreeType from "@/enums/TreeType"
import { useDragAndDrop } from "../store/modules/drag-and-drop";

const store = useTreeStore()
const dragAndDrop = useDragAndDrop()
const searchFilter = computed({
  get() {
    return store.SearchFilter
  },
  set(newValue) {
    store.setSearchFilter(newValue)
  }
})

function SearchSkills() {
   store.filterLists(TreeType.SKILLS)
}

function RemoveSkillFromTree(skill) {
  document.getElementById(`delete-from-tree${skill.tree_id}`)?.click()
}

onMounted(() => {
  store.GetSkills()
});

onUpdated(() => {
  for (let skill of store.SkillsArr) {
    const sitemap = document.getElementById(`skill-sitemap${skill.skill_id}`)

    if(sitemap && skill.sitemap)
      Gems.Tooltip(sitemap, skill.sitemap , "tooltip tooltip-left")

    if (skill.included) {
      const deleteIcon = document.getElementById(`delete${skill.skill_id}`)

      if(deleteIcon)
        Gems.Tooltip(deleteIcon, "Remover da árvore", "tooltip")
    }

    const skillElem = document.getElementById(`skill${skill.skill_id}`)
    if(skillElem) {
      dragAndDrop.setDragFunctionElem(function () {
        skill.fromElementList = true
        dragAndDrop.setDraggedData({element: skill})
      }, skillElem) 
    }
  }
});
</script>

<template>
  <section class="skill-list-section">
    <div class="skill-title">
      <span>Competências</span>
    </div>
    <div class="skill-container">
      <div class="filter">
        <input type="text" v-model="searchFilter" placeholder="Filtrar..." @keyup="SearchSkills" />
      </div>
      <div v-for="(skill, i) in store.SkillsArr" :key="i">
        <div class="skill-line bg-alt-line default-radius" :draggable="true" :id="`skill${skill.skill_id}`" :style="skill.visible">
          <div class="div-icon">
            <i class="fa fa-share fa-flip-horizontal cursor-pointer" :id="`delete${skill.skill_id}`"
              v-if="skill.included ? true : false" @click="RemoveSkillFromTree(skill)"></i>
          </div>
          
          <div class="skill" :id="`skill-sitemap${skill.skill_id}`">
            <span class="line-clamp line-clamp-1">{{ skill.designation }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>

.skill-list-section {
  text-align: center;
  padding: 15px;
  max-width: 450px;
  min-width: 300px;
}

.skill-title {
  padding-bottom: 13px;
}

.skill-line {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  gap: 3px;
}

.skill {
  text-align: start;
  padding: 5px 10px 5px 10px;
  width: 95%;
  margin-left: -5px;
  cursor:grab;
}

.filter {
  margin-bottom: 20px;
}

.filter input {
  width: 100%;
  flex: 3;
}

.filter input::placeholder {
  color: var(--default-font-color);
}


.div-icon {
  width: 5%;
  font-size: 0.8em;
}
</style>